class ContactFormTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = this.tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
    this.onClick = (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tab) this.select(this.tabs.indexOf(tab));
    };
    this.onKeydown = (event) => {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      const current = this.tabs.indexOf(document.activeElement);
      if (current === -1) return;
      const last = this.tabs.length - 1;
      const targets = { ArrowRight: current === last ? 0 : current + 1, ArrowLeft: current === 0 ? last : current - 1, Home: 0, End: last };
      if (!(event.key in targets)) return;
      event.preventDefault();
      this.select(targets[event.key]);
      this.tabs[targets[event.key]].focus();
    };
    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
  }

  select(index) {
    this.tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === index;
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
      tab.classList.toggle('active-heading', isActive);
      const panel = this.panels[tabIndex];
      if (!panel) return;
      panel.hidden = !isActive;
      panel.classList.toggle('active-tab', isActive);
    });
  }
}

if (!customElements.get('contact-form-tabs')) customElements.define('contact-form-tabs', ContactFormTabs);

class ContactStickyBar extends HTMLElement {
  connectedCallback() {
    const hero = document.querySelector('.template-page-contact .image-with-text-overlay');
    if (!hero || !('IntersectionObserver' in window)) {
      this.classList.add('contact-sticky-bar--visible');
      return;
    }
    this.observer = new IntersectionObserver(([entry]) => {
      this.classList.toggle('contact-sticky-bar--visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    this.observer.observe(hero);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('contact-sticky-bar')) customElements.define('contact-sticky-bar', ContactStickyBar);
